import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../utils/api';

export const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      try {
        await api.get('/auth/me');
        setIsAuthenticated(true);
      } catch (error) {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="flex flex-col items-center gap-4">
          
          {/* Spinner */}
          <div className="w-14 h-14 border-4 border-primary/30 border-t-primary rounded-full animate-spin" />

          {/* Brand */}
          <div className="text-center">
            <h1 className="text-xl font-heading font-bold text-gradient">
              CodeSky
            </h1>
            <p className="text-sm text-slate-500 mt-1">
              Loading admin panel...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

export default ProtectedRoute;
